<template>
  <v-container>
    <h2>
      To begin, choose the type of financing you are seeking:
    </h2>

    <DealTypeGrid @continue="nextStep" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

import DealTypeGrid from '@/modules/shared/components/DealTypeGrid'

export default {
  name: 'QuestionnaireDealTypeStep',
  components: {
    DealTypeGrid,
  },

  methods: {
    ...mapActions('questionnaireStore', ['updateMatchData']),
    async nextStep (selected) {
      if (!selected || !selected.length) {
        this.addErrorAlert('Please select at least one option')
      }

      await this.updateMatchData({ dealType: selected })
      this.$emit('finished')
    },
  },
}
</script>

<style lang="scss" scoped></style>
